// Kept browser-safe so the optional WebMCP bridge never imports the server corpus.
export const MCP_PROTOCOL_VERSION = '2025-11-25';
